const rankings = [
  { rank: 1, title: '星河纪元：重启', tag: '科幻', score: '9.2', heat: '本周最热', trend: 'up' },
  { rank: 2, title: '暗夜追踪者', tag: '悬疑', score: '8.9', heat: '新上榜', trend: 'new' },
  { rank: 3, title: '长安十二夜', tag: '古装', score: '8.7', heat: '口碑发酵', trend: 'up' },
  { rank: 4, title: '极地求生', tag: '冒险', score: '8.5', heat: '持续热播', trend: 'stable' },
  { rank: 5, title: '她的名字', tag: '剧情', score: '8.4', heat: '讨论激增', trend: 'up' },
  { rank: 6, title: '深海危机', tag: '灾难', score: '8.2', heat: '关注上升', trend: 'up' },
  { rank: 7, title: '笑傲江湖2026', tag: '喜剧', score: '8.1', heat: '欢乐推荐', trend: 'stable' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50 scroll-mt-16">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-50 text-center mb-3">热门榜单</h2>
        <p className="text-sm text-foreground-500 text-center mb-10 md:mb-14 max-w-lg mx-auto">
          基于观影热度、讨论度与口碑综合排序，发现最受欢迎的电影
        </p>
        <div className="max-w-3xl mx-auto">
          {rankings.map((item, i) => (
            <div
              key={i}
              className={`flex items-center gap-4 px-4 md:px-6 py-4 border-b border-background-200/60 last:border-0 hover:bg-background-100/50 transition-colors cursor-pointer group ${
                i < 3 ? 'bg-gradient-to-r from-primary-500/5 to-transparent' : ''
              }`}
            >
              <span className={`w-8 h-8 flex items-center justify-center rounded-lg text-sm font-bold font-heading flex-shrink-0 ${
                item.rank === 1 ? 'bg-primary-500 text-background-50' :
                item.rank === 2 ? 'bg-accent-500/20 text-accent-400' :
                item.rank === 3 ? 'bg-secondary-500/20 text-secondary-400' :
                'bg-background-200/40 text-foreground-500'
              }`}>
                {item.rank}
              </span>

              <div className="flex-1 min-w-0">
                <h3 className="text-base font-semibold text-foreground-200 group-hover:text-primary-400 transition-colors truncate">{item.title}</h3>
                <div className="flex items-center gap-2 mt-0.5">
                  <span className="text-xs px-2 py-0.5 rounded-full bg-background-200/50 text-foreground-500 whitespace-nowrap">{item.tag}</span>
                  <span className="text-xs text-foreground-600">{item.heat}</span>
                </div>
              </div>

              <div className="flex items-center gap-2 flex-shrink-0">
                <span className="text-lg font-bold font-heading text-primary-400">{item.score}</span>
                <span className="w-5 h-5 flex items-center justify-center">
                  {item.trend === 'up' && <i className="ri-arrow-up-line text-accent-400 text-sm"></i>}
                  {item.trend === 'new' && <i className="ri-sparkling-line text-primary-400 text-sm"></i>}
                  {item.trend === 'stable' && <span className="text-foreground-600 text-xs">—</span>}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}